import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

const UpdateInfluencerOnInfluencedBook = (
  idEan: string,
  userId: string,
  data: {
    [key: string]: string | number | boolean | null
  },
) => {
  return apiInstance.put(
    ApiPathConfig.UPDATE_INFLUENCER_ON_INFLUENCED_BOOK(idEan, userId),
    data,
  )
}

export default UpdateInfluencerOnInfluencedBook
